<template>
  <d-container fluid class="main-content-container px-0">
    <d-card style="width: 100%;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th scope="col" class="border-0">
              {{ $t('service.serviceName') }}
            </th>
            <th scope="col" class="border-0">{{ $t('price.price') }}</th>
            <th scope="col" class="border-0">{{ $t('settings.currency.currency') }}</th>
            <th
              scope="col"
              class="border-0">
              {{ $t('ui.amount') }}
            </th>
            <th scope="col" class="border-0">{{ $t('ui.actions') }}</th>
          </tr>
        </thead>

        <tbody>
          <tr
            v-for="(price, index) of prices"
            :key="'price-' + index">
            <td class="align-middle">
              {{ price.service_name }}
              <template v-if="price.is_setup">({{ $t('service.setup') }})</template>
            </td>
            <td class="align-middle">
              {{ Number(price.price).toFixed(2) }}
            </td>
            <td class="align-middle">
              {{ price.currency_name }}
            </td>
            <td
              class="align-middle">
              <template v-if="price.is_setup">{{ $t('ui.from') }} </template>
              <template v-else>{{ $t('ui.to') }} </template>
              {{ price.value_from }} {{ $t('ui.piecesAbbr') }}
            </td>
            <td
              class="align-middle"
              style="width: 150px;">
              <d-button
                theme="primary"
                @click.prevent="$bus.$emit('contractor-price-popup-open', price);"
                class="mr-2"
                :title="$t('ui.edit')">
                <i class="material-icons">edit</i>
              </d-button>
              <d-button
                theme="danger"
                :disabled="removeInProgress"
                @click.prevent="removePrice(price.id)"
                :title="$t('ui.delete')">
                <i class="material-icons">delete</i>
              </d-button>
            </td>
          </tr>
          <tr v-if="prices.length === 0">
            <td
              colspan="5"
              class="text-center">
              {{ $t('price.noPricesToDisplay') }}&hellip;
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center overlay-loading">
        {{ $t('ui.dataLoading') }}&hellip;
      </div>

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        {{ $t('ui.dataLoadingFailed') }} <a href="javascript:window.location.reload();" class="alert-link">{{ $t('ui.refreshPage') }}</a> {{ $t('ui.toTryAgain') }}
      </d-alert>
    </d-card>

    <pagination
      :meta-data="paginationMetaData"
      :initial-page="currentPage" />
  </d-container>
</template>

<script>
import debounce from 'lodash.debounce';
import HasPagination from './../../mixins/HasPagination.vue';
import ListUtils from './../../utils/ListUtils.js';
import Pagination from './../../components/common/Pagination.vue';

export default {
  name: 'contractor-prices',
  mixins: [
    HasPagination
  ],
  props: {
    contractorId: {
      default: 0,
      type: Number
    }
  },
  components: {
    'pagination': Pagination
  },
  computed: {
    allDataLoaded () {
      return this.loaded;
    }
  },
  data() {
    return {
      prices: [],
      loaded: false,
      loadError: false,
      removeInProgress: false
    };
  },
  mounted () {
    this.loadFilteredData();
    this.$bus.$on('contractor-prices-reload-needed', this.loadFilteredData);
  },
  methods: {
    debouncedLoadFilteredData: debounce(function () {
      this.$bus.$emit('view-filters-save');
      this.loadFilteredData();
    }, 250),
    loadFilteredData () {
      ListUtils.loadPaginatedItemsData(this, {
        endpoint: '/contractors/prices/items?page=' + this.currentPage,
        listField: 'prices',
        params: {
          where: {
            contractor_id: this.contractorId
          }
        }
      });
    },
    removePrice (priceID) {
      this.removeInProgress = true;

      ListUtils.removeItem({
        $http: this.$http,
        endpointBase: '/contractors/prices/delete/',
        id: priceID,
        successTitle: this.$t('price.deletePriceSuccessTitle'),
        successText: this.$t('price.deletePriceSuccessText'),
        confirmTitle: this.$t('price.deletePriceConfirmTitle'),
        confirmText: this.$t('ui.deleteConfirmText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('price.deletePriceErrorText'),
        successAction: () => {
          this.removeInProgress = false;
          this.loadFilteredData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    }
  },
  beforeDestroy () {
    this.$bus.$off('contractor-prices-reload-needed', this.loadFilteredData);
  }
};
</script>

